import React from "react";
import ReactDOM from "react-dom";
// import "./index.css";

import App from "./App";

import "devextreme/dist/css/dx.common.css";
// import "devextreme/dist/css/dx.material.teal.light.css";
import "devextreme/dist/css/dx.material.teal.light.compact.css";

import "./index.css";

import { Provider } from "react-redux";
// import { RecoilRoot } from "recoil";
import reportWebVitals from "./reportWebVitals";
// import Test from "./components/openAPI/Visualization/Test";

import { store } from "./components/common/Redux/store";
import "./api/setupAxios";

ReactDOM.render(
  <Provider store={store}>
    {/* <RecoilRoot> */}
    <App />
    {/* <BrowserRouter>
      <Routes>
        <Route path="EqptMgmt" element={<EquipmentManagement />} />
        <Route path="EqptMgmt/:type/:SEQ" element={<QR />} />
        <Route
          path="MdcinClincTestInfoService01"
          element={<MdcinClincTestInfoService01 />}
        />
        <Route
          path="ClinicTestOprtnInsttInfoService01"
          element={<ClinicTestOprtnInsttInfoService01 />}
        />
        <Route path="Indication" element={<Indication />} />
        <Route path="SOPViewer" element={<SOPViewer />} />
        <Route path="LrnMgmt" element={<Training />} />

        <Route path="ContrReg" element={<ContractRegistration />} />
        <Route path="PrjAsgmt" element={<ProjectAssign />} />
        <Route path="WorkR" element={<WorkRecord />} />

        <Route path="Visualization" element={<Visualization />} />
        { <Route path="_Visualization" element={<_Visualization />} /> }
      </Routes>
    </BrowserRouter> */}
    {/* </RecoilRoot> */}
  </Provider>,
  document.getElementById("root")
);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
